import React, { useEffect } from 'react';
const pixelId = '1475685237698537';
const pixelSnippet = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${pixelId}');
fbq('track', 'PageView');`;

/**
 * Injects the official Meta Pixel base code exactly as provided by Meta.
 */
export function MetaPixel() {
  useEffect(() => {
    if (document.getElementById('meta-pixel-code')) return;
    const script = document.createElement('script');
    script.id = 'meta-pixel-code';
    script.text = pixelSnippet;
    document.head.appendChild(script);
  }, []);
  return <noscript data-id="element-83" data-mp="rk7ges7fr4hz">
      <img alt="" height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`} data-id="element-84" data-mp="rkqws4hftktw" />
    </noscript>;
}